import dayjs, { Dayjs } from "dayjs";
import isLeapYear from "dayjs/plugin/isLeapYear";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import isoWeek from "dayjs/plugin/isoWeek";
import updateLocale from "dayjs/plugin/updateLocale";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import zh from "dayjs/locale/zh-cn";
import en from "dayjs/locale/en-au";

import { TimeCycleType } from "../types/form-type";

import { getCookie } from "./cookies";

const local = getCookie("locale");
if (local === "zh") dayjs.locale(zh);
if (local === "en") dayjs.locale(en);

dayjs.extend(isLeapYear);
dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
dayjs.extend(weekday);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(localeData);

// 设置一周的起始
dayjs.updateLocale("zh", {
  weekStart: 1,
});

// 获取时间戳
export const getTimeValue = (str: string): number => dayjs(str).valueOf();

const getTimeStrFunc: { [key in string]: (timeStr: string) => string } = {
  [TimeCycleType.DAY]: (timeStr) => dayjs(timeStr).format("YYYY-MM-DD"),
  [TimeCycleType.WEEK]: (timeStr) =>
    dayjs(timeStr)
      .subtract(dayjs(timeStr).isoWeekday() - 1, "day")
      .format("YYYY-MM-DD"),
  [TimeCycleType.MONTH]: (timeStr) => dayjs(timeStr).format("YYYY-MM"),
  [TimeCycleType.QUARTER]: (timeStr) => `${dayjs(timeStr).year()} Q${dayjs(timeStr).quarter().toString()}`,
  [TimeCycleType.YEAR]: (timeStr) => dayjs(timeStr).format("YYYY"),
};

export const getTimeCycleStr = (timeStr: string, groupAtCycle: TimeCycleType): string => {
  if (!dayjs(timeStr).isValid()) return timeStr;
  return getTimeStrFunc[groupAtCycle](timeStr);
};

export const checkTimeValid = (timeStr: string): boolean => {
  return dayjs(timeStr).isValid();
};

export const formatTime = (timeStr: string | number, formatStr: string): string => {
  const time = dayjs(timeStr);
  if (!time.isValid()) return `${timeStr}`;
  return time.format(formatStr);
};

const convertTimeCycleFunc: { [key in string]: (timeStr: string) => string } = {
  [TimeCycleType.DAY]: (timeStr) => dayjs(timeStr).startOf("day").toISOString(),
  [TimeCycleType.WEEK]: (timeStr) => dayjs(timeStr).startOf("isoWeek").toISOString(),
  [TimeCycleType.MONTH]: (timeStr) => dayjs(timeStr).startOf("month").toISOString(),
  [TimeCycleType.QUARTER]: (timeStr) => dayjs(timeStr).startOf("quarter").toISOString(),
  [TimeCycleType.YEAR]: (timeStr) => dayjs(timeStr).startOf("year").toISOString(),
};

export const convertTimeCycle = (timeStr: string, groupAtCycle: TimeCycleType): string => {
  const timeObj = dayjs(timeStr);
  if (!timeObj.isValid()) return timeStr;
  const newTimeStr = convertTimeCycleFunc[groupAtCycle](timeObj.toISOString());
  return newTimeStr;
};

// 将 DATETIME 列的 celllValue 转化成统一格式的 ISOString  对于非法值不做处理
export const convertDateISOString = (str: string): string => {
  return checkTimeValid(str) ? dayjs(str).toISOString() : str;
};
